import { render } from "./SaveInlay.vue?vue&type=template&id=c89e625a"
import script from "./SaveInlay.vue?vue&type=script&lang=js"
export * from "./SaveInlay.vue?vue&type=script&lang=js"
script.render = render

export default script